import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ValidatorForm } from 'react-material-ui-form-validator';

import Box from '@quintoandar/cozy-core/Box';
import Input from '@quintoandar/cozy-core/Input/Input';
import Typography from '@quintoandar/cozy-core/Typography';
import messages from './messages';

export const SpacedInput = ({
  id,
  value,
  onChange,
  onBlur,
  intlKey,
  maxLength,
  withCounter,
  multiline,
  onValidateItem,
  shouldValidate,
}) => {
  const [valid, setValid] = useState(true);

  const hasValue = Boolean(value);

  useEffect(
    () => {
      if (onValidateItem) {
        onValidateItem(hasValue);
      }
    },
    [hasValue],
  );

  useEffect(
    () => {
      if (shouldValidate && valid !== hasValue) {
        setValid(hasValue);
      }
    },
    [shouldValidate, valid, hasValue],
  );

  const ref = useRef(null);

  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    ref.current?.classList.add('MuiInputBase-input');
  }, []);

  return (
    <Box my={2}>
      <ValidatorForm>
        <Input
          id={id}
          ref={ref}
          name={id}
          label={messages[intlKey] || messages.notFoundMessage}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          maxLength={maxLength}
          multiline={multiline}
          withCounter={withCounter}
          fullWidth
        />
      </ValidatorForm>
      {!valid && (
        <Typography kind="critical">
          <FormattedMessage {...messages.invalid} />
        </Typography>
      )}
    </Box>
  );
};

SpacedInput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  intlKey: PropTypes.string,
  maxLength: PropTypes.number,
  multiline: PropTypes.bool,
  withCounter: PropTypes.bool,
  onValidateItem: PropTypes.func,
  shouldValidate: PropTypes.func,
};

export default SpacedInput;
